
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SideNavComponent } from './core/_layout/sidenav/sidenav.component';
import { AdminSidenavComponent } from './core/admin-layout/admin-sidenav/admin-sidenav.component';
import { authGuard } from './core/guards/auth.guard';



const routes: Routes = [
    { path: '',
    component: SideNavComponent,canActivate:[],
    children: [
      {path:'',redirectTo:'home',pathMatch:'full'},
      {path:'home',loadChildren:()=>import('./features/search-engine/search-engine.module').then(m=>m.SearchEngineModule)},
      {path:'about-us',loadChildren:()=>import('./features/about-us/about-us.module').then(m=>m.AboutUsModule)},
      {path:'scheme',loadChildren:()=>import('./features/udyam-scheme/udyam-scheme.module').then(m=>m.UdyamSchemeModule)},
      {path:'calculator',loadChildren:()=>import('./features/financial-calculators/financial-calculators.module').then(m=>m.FinancialCalculatorsModule)},
      {path:'explore-scheme',loadChildren:()=>import('./features/explore-scheme/explore-scheme.module').then(m=>m.ExploreSchemeModule)},
      // Public event registration. Sits in this block, not the admin one, precisely because
      // it must be reachable without a login.
      {path:'events',loadChildren:()=>import('./features/public-events/public-events.module').then(m=>m.PublicEventsModule)},
      // Public feedback. Same reason as events: an open user must reach it without a login.
      {path:'feedback',loadChildren:()=>import('./features/public-feedback/public-feedback.module').then(m=>m.PublicFeedbackModule)},

    ]},
    { path: '',
    children: [
      {path:'user',loadChildren:()=>import('./features/account/account.module').then(m=>m.AccountModule)},
      {path:'redirect',loadChildren:()=>import('./features/redirect-from-other-app/redirect-from-other-app.module').then(m=>m.RedirectFromOtherAppModule)},
      // {path:'redirect-ubp',loadChildren:()=>import('./features/redirect-from-other-app/redirect-ubp/redirect-ubp.module').then(m=>m.RedirectUbpModule)},
      // {path:'redirect-pms-to-ubp',loadChildren:()=>import('./features/redirect-from-other-app/pms-to-ubp/pms-to-ubp.module').then(m=>m.PmsToUbpModule)},
      // {path:'ubp-e-sign',loadChildren:()=>import('./features/redirect-from-other-app/e-sign-ubp/e-sign-ubp.module').then(m=>m.ESignUBPModule)},

    ]},
    {path: '',
    component: SideNavComponent,canActivate:[],
    children: [
    { path: 'apply-scheme', loadChildren: () => import('./features/udyam-scheme/apply-scheme/apply-scheme.module').then(m => m.ApplySchemeModule) },
    { path: 'msme-zed', loadChildren: () => import('./features/udyam-scheme/apply-scheme/msme-zed/msme-zed.module').then(m => m.MsmeZedModule) },
    { path: 'msme-lean', loadChildren: () => import('./features/udyam-scheme/apply-scheme/msme-lean/msme-lean.module').then(m => m.MsmeLeanModule) },
]},

    { path: '',
    component: AdminSidenavComponent,
    canActivate: [authGuard],
    data: { role: [2, 10, 14, 15, 16, 17, 19, 20] },
    children: [
      {path:'dashboard',loadChildren:()=>import('./features/Admin/dashboard/dashboard.module').then(m=>m.DashboardModule)},
      {path:'master',loadChildren:()=>import('./features/Admin/master/master.module').then(m=>m.MasterModule)},
      {path:'know-your-scheme',loadChildren:()=>import('./features/Admin/know-your-scheme/know-your-scheme.module').then(m=>m.KnowYourSchemeModule)},
      {path:'ticketing-master',loadChildren:()=>import('./features/Admin/ticketing-master/ticketing-master.module').then(m=>m.TicketingMasterModule)},
      {path:'ticket-management',loadChildren:()=>import('./features/Admin/ticket-management/ticket-management.module').then(m=>m.TicketManagementModule)},
      {path:'feedback-master',loadChildren:()=>import('./features/Admin/feedback-master/feedback-master.module').then(m=>m.FeedbackMasterModule)},
      {path:'feedback-management',loadChildren:()=>import('./features/Admin/feedback-management/feedback-management.module').then(m=>m.FeedbackManagementModule)},
      {path:'event-management',loadChildren:()=>import('./features/Admin/event-management/event-management.module').then(m=>m.EventManagementModule)},
      {path:'dept-dashboard-master',loadChildren:()=>import('./features/Admin/dept-dashboard-master/dept-dashboard-master.module').then(m=>m.DeptDashboardMasterModule)},
      {path:'user-management',loadChildren:()=>import('./features/Admin/user-management/user-management.module').then(m=>m.UserManagementModule)},
      {path:'admin-profile',loadChildren:()=>import('./features/Admin/admin-profile/admin-profile.module').then(m=>m.AdminProfileModule)},
      {path:'cms',loadChildren:()=>import('./features/Admin/cms/cms.module').then(m=>m.CmsModule)},
    ]},

    // { path: '',
    // children: [
    //   {path:'login',loadChildren:()=>import('./features/Admin/admin-login/admin-login.module').then(m=>m.AdminLoginModule)},

    // ]},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
